const ERROR_TYPE = {
    PROCESSING_EXCEPTION: 'ProcessingException',
    VALIDATION_EXCEPTION: 'ValidationException',
} as const;

export default ERROR_TYPE;
